/* Publish by EComposer at 2026-11-01 16:56:24*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-frsyf1ok88t"]=  window.__ectimmers["ecom-frsyf1ok88t"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-frsyf1ok88t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-frsyf1ok88t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1z9i9zd4r2rj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1z9i9zd4r2rj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pky4vs6z84e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pky4vs6z84e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9pcbge2stfo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9pcbge2stfo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m3lhy6vdi1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m3lhy6vdi1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kxh09bekxfl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kxh09bekxfl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7t42x0hriqq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7t42x0hriqq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2s0gyeewrl4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2s0gyeewrl4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w9pycg3h2od').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w9pycg3h2od', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kca1dcxs7w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kca1dcxs7w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a25affuci6u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a25affuci6u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jdjiila8wk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jdjiila8wk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4wc6submut5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4wc6submut5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e18sq3qvguh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e18sq3qvguh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xe0ccfwls4c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xe0ccfwls4c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d6p5hpcsafd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d6p5hpcsafd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bxj01ggw9rp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bxj01ggw9rp', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-p25b8x3kki"]=  window.__ectimmers["ecom-p25b8x3kki"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-p25b8x3kki"]["mw03byutk"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-p25b8x3kki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p25b8x3kki', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qe7rxegmx5s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qe7rxegmx5s', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rfdg4nrnlhn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rfdg4nrnlhn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bt8dcgp6en5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bt8dcgp6en5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9pa2squaaaf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9pa2squaaaf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kotzj2o7k7r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kotzj2o7k7r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-49hs4dzwbhg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-49hs4dzwbhg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hj0f085ivfl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hj0f085ivfl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-st4zlf5zul').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-st4zlf5zul', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p0qp7uq3aho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p0qp7uq3aho', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v62261eb43m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v62261eb43m', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9bkznw8dx1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9bkznw8dx1', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fgz6rhcpp5d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fgz6rhcpp5d', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sr0btq85cnl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sr0btq85cnl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iqzakbpw4j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iqzakbpw4j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3rqpae1jmmj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3rqpae1jmmj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q8wsyqwxdqs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q8wsyqwxdqs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jtav8wpmz0d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jtav8wpmz0d', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n2todbnnccs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n2todbnnccs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-25r2a4f49yx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-25r2a4f49yx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zbzgaposhes').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zbzgaposhes', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wxfp3goq91g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wxfp3goq91g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xctae1wzewn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xctae1wzewn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-on4rmkypnxn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-on4rmkypnxn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3sbrkwano75').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3sbrkwano75', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cc6vs266g4u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cc6vs266g4u', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dzqabwwij07').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dzqabwwij07', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hr69em3nc9w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hr69em3nc9w', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ig316anv9o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ig316anv9o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m4fee56ml5r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m4fee56ml5r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wtzpjzqguan').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wtzpjzqguan', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gixtps2aov').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gixtps2aov', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oam5jyu8dl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oam5jyu8dl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wfu21gpvbc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wfu21gpvbc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-orw9s6r09v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-orw9s6r09v', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dwxq3v7njs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dwxq3v7njs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c60lu5kqoza').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c60lu5kqoza', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rtoj732omaq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rtoj732omaq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1zc9jai7uha').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1zc9jai7uha', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v2mlfgwzs7j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v2mlfgwzs7j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-14d8rl2m3wd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-14d8rl2m3wd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o1v5p1i6zq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o1v5p1i6zq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b330mqpule').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b330mqpule', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mkgq36gybgo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mkgq36gybgo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z75dg89oze').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z75dg89oze', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9mjs6t3v2t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9mjs6t3v2t', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jj5t20ovhd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jj5t20ovhd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6qtpbikt4b7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6qtpbikt4b7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d4l1ifuq61n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d4l1ifuq61n', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1wx3dp5rrq3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1wx3dp5rrq3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-arja054o4gk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-arja054o4gk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ihv37tgw8c8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ihv37tgw8c8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fyb8hyq4dyh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fyb8hyq4dyh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ioutr1669p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ioutr1669p', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-08zuzwcld4y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-08zuzwcld4y', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-opfd05qulrk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-opfd05qulrk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7bl2l4xr1m8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7bl2l4xr1m8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hbj5z126aea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hbj5z126aea', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lsz4cr6qst').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lsz4cr6qst', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u7oqtd6obp9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u7oqtd6obp9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wj7hzu7qsl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wj7hzu7qsl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ih3qvlgnat').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ih3qvlgnat', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6pt5yr3rq5m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6pt5yr3rq5m', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-02ykruvximzq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-02ykruvximzq', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rmv0all2nkr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rmv0all2nkr', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zxhl0xcvf2p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zxhl0xcvf2p', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}